
import Vuex from 'vuex';
import resetpassword from './modules/resetpassword';
import filter from './modules/filter';
import share from './modules/share';
import signin from './modules/signin';

const Store = (Vue) => {

	Vue.use(Vuex);

	return new Vuex.Store({
		  modules: {
		    resetpassword,
				filter,
				share,
				signin,
		},
	});
}

export default Store;



// WEBPACK FOOTER //
// ../shared/store/index.js